/* eslint-disable no-prototype-builtins */
const exisits = (element: any) => !!element

export const existsFilters = (filters: any) => {
  for (const key in filters) {
    if (
      filters.hasOwnProperty('listMode') &&
      (filters.hasOwnProperty('statusId') ||
        filters.hasOwnProperty('dateRange') ||
        filters.hasOwnProperty('sellerId') ||
        filters.hasOwnProperty('customerId')) &&
      Array.isArray(filters[key])
    ) {
      return !filters[key]?.some(exisits)
    } else if (
      (filters.hasOwnProperty('listMode') &&
        !filters.hasOwnProperty('statusId')) ||
      !filters.hasOwnProperty('dateRange') ||
      !filters.hasOwnProperty('sellerId') ||
      !filters.hasOwnProperty('customerId')
    ) {
      return ''
    }

    if (filters[key]) return true
  }

  return false
}
